import React, { useEffect, useState, useCallback } from 'react';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import DropDownButton from 'devextreme-react/drop-down-button';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';
import { UserForm, } from '../../components';
import { withLoadPanel } from '../../utils/withLoadPanel';
import './user_edit.scss';
import ScrollView from 'devextreme-react/scroll-view';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiToken } from '../../utils/authUtils.js';
import notify from 'devextreme/ui/notify';
import { useMsal } from "@azure/msal-react";
const UserFormWithLoadPanel = withLoadPanel(UserForm);
export const UserDetails = () => {
      const { instance, accounts } = useMsal();
    const [data, setData] = useState();
    const [userData, setuserData] = useState({});
    const [clubData, setclubData] = useState([])
    const [trainingsgroupData, settrainingsgroupData] = useState([])
    const [notes, setNotes] = useState();
    const [messages, setMessages] = useState([]);
    const [activeOpportunities, setActiveOpportunities] = useState();
    const [closedOpportunities, setClosedOpportunities] = useState();
    const [isLoading, setIsLoading] = useState(false);

    let { userId } = useParams()
    const navigate = useNavigate();

    const onLeftClick = () => {
        navigate(-1);
    };
    useEffect(() => {
        loadData();
    }, []);

    const loadData = useCallback(() => {

        getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
                key: 'userId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/User/Users`,
                insertUrl: `${process.env.REACT_APP_serverEndpoint}/User/InsertUser`,
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/User/UpdateUser`,
                deleteUrl: `${process.env.REACT_APP_serverEndpoint}/User/DeleteUser`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            const dataSource_permissiongroup = createStore({
                key: 'permissiongroupId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/PermissiongroupsBasic`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });


            Promise.all([
                dataSource.load({ filter: ['userId', '=', userId] })
                
           ]).then((values) => { setData({ user: values[0][0], permissiongroups: dataSource_permissiongroup }); setIsLoading(false); }).catch((error) => console.log(error));


        });

    }, []);

    const refresh = useCallback(() => {
        setIsLoading(true);
        loadData();
    }, []);
    const onSave = useCallback((data) => {
        getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
                key: 'userId',
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/User/UpdateUser`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            dataSource.update(data.userId, data).then(() => {
                notify({
                    message: `Benutzer "${data.displayName}" gespeichert`,
                    position: { at: 'bottom center', my: 'bottom center' }
                },
                    'success'
                );
            }
            );
        })
    }, []);

    return (
        <ScrollView className='view-wrapper-scroll'>
            <div className='view-wrapper view-wrapper-user-details'>
                <Toolbar className='toolbar-details theme-dependent'>
                    <Item location='before'>
                        <Button icon='arrowleft' stylingMode='text' onClick={onLeftClick} />
                    </Item>
                    <Item location='before' text={function () {
                        if (!!data) {

                            return data?.user?.displayName
                        } else {
                            return 'Lädt...'
                        }

                    }} />
                    {/* <Item location='after' locateInMenu='auto'>
                        <Button
                            text='Terminate'
                            type='default'
                            stylingMode='contained'
                        />
                    </Item>
                    <Item location='after'>
                        <DropDownButton
                            text='Actions'
                            stylingMode='text'
                            dropDownOptions={{ width: 'auto' }}
                            items={['Assign to Me', 'Archive']}
                        />
                    </Item>
                    <Item location='after' locateInMenu='auto'>
                        <div className='separator' />
                    </Item>
                    <Item
                        location='after'
                        locateInMenu='auto'
                        widget='dxButton'
                        showText='inMenu'
                    >
                        <Button
                            text='Copy'
                            icon='copy'
                            stylingMode='text'
                        />
                    </Item>
                    <Item
                        location='after'
                        locateInMenu='auto'
                        widget='dxButton'
                        showText='inMenu'
                    >
                        <Button
                            text='Refresh'
                            icon='refresh'
                            stylingMode='text'
                            onClick={refresh}
                        />
                    </Item> */}
                </Toolbar>

                <div className='panels'>
                    <div className='left'>
                        <UserFormWithLoadPanel
                            loading={isLoading}
                            hasData={!!data}
                            data={data}
                            onSave={onSave}
                        />
                    </div>


                </div>
            </div>
        </ScrollView>
    );
};


